import { getFilterDates } from '@philips-emr/hpms-stipulator-commons';
import { HPMSOnCreateOption, HPMSOnOptionClick } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { HpmsCustomCardEvent, HpmsCustomCardMenuRenderEvent } from '@philips-emr/hpms-stipulator-components/lib/types';
import { FilterAPI } from '@philips-emr/tws-components';
import Controller, { OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseMensalidadeCustomCardController, { Mensalidade } from './base-mensalidade-custom-card-controller';

@Controller({ fragment: 'mensalidades' })
export default class MensalidadeController extends BaseMensalidadeCustomCardController {

  @OnMount('filter-mensalidades')
  public onMountFilter(event: MountEvent): void {
    const api = event.target as FilterAPI;

    api.setData(getFilterDates('dtInicio', 'dtFim', 12));
  }

  @OnMount('filtered-list')
  public onMountFetchMensalidades(): void {
    super.onMountFetchMensalidades();
  }

  @OnDynamicContentRender('hpms-dynamic-content-situacao')
  public onDynamicContentRenderCardLote(event: RenderEvent): void {
    super.onDynamicContentRenderCardLote(event);
  }

  @HPMSOnCreateOption('hpms-custom-card')
  public onCreateOption(event: HpmsCustomCardMenuRenderEvent<Mensalidade>): void {
    super.onCreateOption(event);
  }

  @HPMSOnOptionClick('hpms-custom-card')
  public onOptionClick(event: HpmsCustomCardEvent<Mensalidade>): void {
    super.onOptionClick(event);
  }

}
